/* tslint:disable */

/* ********************************************************
 * THIS FILE IS AUTO GENERATED BY A TOOL - DO NOT CHANGE IT
 * RUN npm run openapi-client-gen TO REGENERATE THE FILE
 * *******************************************************/

import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { UserInfo } from '../models/user-info';
import { FuldmagtInfo } from '../models/fuldmagt-info';
@Injectable({
  providedIn: 'root',
})
class UserService extends __BaseService {
static readonly clearCachePath = '/users/clearcache';
static readonly getUserInfoPath = '/users/userinfo';
static readonly logoutPath = '/users/logout';
static readonly getFuldmagterPath = '/users/fuldmagter';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  private clearCacheResponse(): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/users/clearcache`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  clearCache(): __Observable<null> {
    return this.clearCacheResponse().pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @return Success
   */
  private getUserInfoResponse(): __Observable<__StrictHttpResponse<UserInfo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/users/userinfo`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UserInfo>;
      })
    );
  }

  /**
   * @return Success
   */
  getUserInfo(): __Observable<UserInfo> {
    return this.getUserInfoResponse().pipe(
      __map(_r => _r.body as UserInfo)
    );
  }
  private logoutResponse(): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/users/logout`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  logout(): __Observable<null> {
    return this.logoutResponse().pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @return Success
   */
  private getFuldmagterResponse(): __Observable<__StrictHttpResponse<Array<FuldmagtInfo>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/users/fuldmagter`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<FuldmagtInfo>>;
      })
    );
  }

  /**
   * @return Success
   */
  getFuldmagter(): __Observable<Array<FuldmagtInfo>> {
    return this.getFuldmagterResponse().pipe(
      __map(_r => _r.body as Array<FuldmagtInfo>)
    );
  }
}

module UserService {
}

export { UserService }
